import React, { Component } from 'react';
import OptionButtonEvent from './OptionButtonEvent';
import TitleSectionEvent from './TitleSectionEvent';
import DeviceStorage from '../../DeviceStorage/DeviceStorage';
import Asset from '../../../requests/apa/Asset';
import Translator from '../../../requests/apa/Translator';
import { VCARD_NPVR_RECORDED } from '../../../AAF/Npvr/Constans';

class LangVod extends Component {
    constructor(props = {}) {
        super(props);
        this.state = {
            items: [],
        };
        this.activeLang = DeviceStorage.getItem('default_lang') || false;
        this.imageButton_audio = Asset.get('modal_option_vod_audio_icon', '/images/ic_audio.png');
        this.imageButton_subtitle = Asset.get('modal_option_vod_subtitle_icon', '/images/ic_subtitle.png');
    }

    getLangOptions = (langs) => {
        return langs.map((lang) => {
            const { label_large = '', option_id = '', subtitle = null } = lang;
            const active = this.activeLang === option_id;
            return {
                item: (
                    <OptionButtonEvent
                        title={label_large}
                        onClick={() => {
                            this.changeLang(lang);
                        }}
                        active={active}
                        image={subtitle ? this.imageButton_subtitle : this.imageButton_audio}
                    />
                ),
            };
        });
    };

    sendMetric = (lang) =>{
        if(this.props && (typeof this.props.sendMetric === 'function') && lang && lang.label_large){
            this.props.sendMetric(lang.label_large,'idioma', VCARD_NPVR_RECORDED);
        }
    }

    changeLang = (langCode) => {
        if(this.activeLang === langCode.option_id) return;
        this.activeLang = langCode.option_id;
        if (typeof this.props.changeLang === 'function') {
            this.props.changeLang(langCode);
            this.sendMetric(langCode);
            typeof this.props.handleClose === 'function' && this.props.handleClose();
        }
    };

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        const { data: { languageOptions = [] } = {} } = this.props;
        const items = [
            {
                item: languageOptions.length > 0 ? <TitleSectionEvent title={Translator.get('panelOptions_sidemenu_title_selectLanguage_label', 'IDIOMA')} /> : null,
            },
            ...this.getLangOptions(languageOptions),
        ];
        this.setState({ items }, () =>{
            window.SpatialNavigation.focus('.event_option_button_section');
        });
    };

    componentWillMount() {}

    render() {
        const { items = [] } = this.state;
        return (
            <div>
                {items &&
                    Array.isArray(items) &&
                    items.map((componentLang) => {
                        return componentLang.item;
                    })}
            </div>
        );
    }
}

export default LangVod;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/LangVod.jsx